var SELECTED_TAB = '';
$(document).ready(function() {
	
	CommonPayment.source = $("[name=source]").val();
	
	if (!Object.keys) {
		  Object.keys = function(obj) {
		    var keys = [];

		    for (var i in obj) {
		      if (obj.hasOwnProperty(i)) {
		        keys.push(i);
		      }
		    }

		    return keys;
		  };
	}
	
	$('.ccnumber').keypress(function (e) {
		 var regex = new RegExp("^[0-9]*$");
		 var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
	    return regex.test(str) ? true : false;
	});
	
	// InternetExporer does not have filter function
	if (!Array.prototype.filter) {
	  Array.prototype.filter = function(fun /*, thisp */)
	  {
	    "use strict";
	    if (this === void 0 || this === null)
	      throw new TypeError();

	    var t = Object(this);
	    var len = t.length >>> 0;
	    if (typeof fun !== "function")
	      throw new TypeError();

	    var res = [];
	    var thisp = arguments[1];
	    for (var i = 0; i < len; i++)
	    {
	      if (i in t){
	        var val = t[i]; // in case fun mutates this
	        if (fun.call(thisp, val, i, t))
	          res.push(val);
	      }
	    }
	    return res;
	  };
	}
	
	$("#ticketForm, #reservationForm, #orderForm, #updateOrderInfo, #paymentForm").letterCase($.cookie('siteLocale')).validate({
		focusInvalid: false
	    ,invalidHandler: function(form, validator) {
	        if (!validator.numberOfInvalids()){
	            return;
	    	}
	        $('html, body').animate({
	            scrollTop: $(validator.errorList[0].element).offset().top
	        }, 500);
	    }
		, showErrors: function(errorMap, errorList) {
		    this.defaultShowErrors();
		    trackNotValidElements(errorList);
		}
		
	});
	
	$("#cc_expire_month, #cc_expire_year, #masterpass_cc_expire_month, #masterpass_cc_expire_year").change(function() {
        var selectedValue = this.options[this.selectedIndex].text;
        $(this).parent().find('.field-value-select').text(selectedValue);
    });
	
	if(siteId == 1){
		$("#gsm, #phone, #masterpassGsm").mask("(999) 999-9999");
	}else{
		$("#gsm, #phone, #masterpassGsm").mask("999999999999999");
	}
	

	$(".tcno").mask("99999999999");
	$(".irsaNo").mask("9999999999");


	$(".agreeCheckBox").click(function() {
		var agree = $(this).prop("checked");
		var checked = false;
		if (agree) {
			checked = true;
			$(".agreeCheckBox").prop("checked", true );
		}else{
			$(".agreeCheckBox").prop("checked", false );
		}
	});
	
	$(".agreeCheckBox").iCheck('uncheck');
	
	$(".ccnumber").mask("9999 9999 9999 9999");
	$(".ccsecuritynumber").mask("999");
	$("#ccForm").validate();
	
	$(".passCitizenshipCountryAttr").click(function(event) {
		var currentName = $(this).attr('name');
		$("#" + currentName).val($(this).val());
	});
	
	$(".passCitizenshipCountryAttr").val(CommonPayment.countryCode);
	
	$(".passIssueCountryAttr").click(function(event) {
		var currentName = $(this).attr('name');
		$("#" + currentName).val($(this).val());
	});
	
	$(".passCitizenshipCountryAttr").msDropdown();
		
	$( "#payment-tabs" ).tabs();
	
	$( "#payment-tabs" ).on( "tabsactivate", function(event, ui) {
		var selectedTab = ui.newTab.attr("aria-labelledby");
		SELECTED_TAB = selectedTab;
		if (selectedTab == 'cc-noinstallment-tab-li') {
			$("#cardBrandFeeDiv").show();
			$("[name=metasearchCardBrandFee]").val($("#metasearchCardBrandFeeSelect option:selected").val());
			$('input[name=paymentType]').val(1);

		} else if (selectedTab == 'booking-money-transfer-tab-li') {
			$("[name=metasearchCardBrandFee]").val("");
			$('input[name=paymentType]').val(0);
		}else if (selectedTab == 'booking-tab-li') {
			$("[name=metasearchCardBrandFee]").val("");
			$('input[name=paymentType]').val(0);
		} else if (selectedTab == 'mywallet-tab-li') {
			$("[name=metasearchCardBrandFee]").val("");
			$('input[name=paymentType]').val(2);
		}
		else if(selectedTab == 'masterpass-tab'){
            getMasterpassSelectedCardInstallments();
		} else if(selectedTab.startsWith("alernative-payments-tab")){
			var installmentRate = $(this).find("#btnAlternativePayment").data("installmentrate");
			
			var total = CommonPayment.totalAmount - CommonPayment.discountAmount;
			var alternativePaymentRate = parseFloat(installmentRate / 100);
			var alternativeAmount = parseFloat(total) * parseFloat(alternativePaymentRate);
			total = parseFloat(total) + parseFloat(alternativeAmount);
			total = total.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + CommonPayment.totalCurrency;

			$('.alternativePaymentAmount').html(total);			
		}
	});
		
	
	reloadPaymentTabOnInit();
	
	$("#moneyTransAccInfListSelect").change(function() {
		var value = $(this.options[this.selectedIndex]).val();
		$(".accBankInfo").hide();
		$("#accBankInfo_" + value).show();
	});

	$("#bankSelect, #moneyTransAccInfListSelect").change(function() {
		var selectedText = this.options[this.selectedIndex].text;
		$(this).parent().find('.field-value-select').text(selectedText);
	});

	$("#moneyTransAccInfListSelect").change();

	$("#gsm_code").intlTelInput({
		preferredCountries: [CommonPayment.countryCode],
		americaMode: false
	})


	$("#gsm_code").focusout(function(){
		var isTR = $("[name=gsm_code]").val().includes("+90");
		if(isTR){
			$("[name=gsm]").mask("(999) 999-9999");
		}else{
			$("[name=gsm]").mask("999999999999999");
		}
	});

	$('.genderMale').each(function(){
	    var self = $(this),
	      label = self.next(),
	      label_text = label.text();

	    label.remove();
	    self.iCheck({
	      checkboxClass: 'icheckbox_flat-male',
	      radioClass: 'iradio_flat-male',
	      insert: '<div class="icheck_flat-icon"></div>' + label_text
	    });
	});
	
	$('.genderFemale').each(function(){
	    var self = $(this),
	      label = self.next(),
	      label_text = label.text();

	    label.remove();
	    self.iCheck({
	      checkboxClass: 'icheckbox_flat-female',
	      radioClass: 'iradio_flat-female',
	      insert: '<div class="icheck_flat-icon"></div>' + label_text
	    });
	  });
	
	$('.genderRadio').on('ifChanged', function(event){
		 $(this).valid(); 
	});
	
	$(".adultDatePicker, .datepicker").change(function() {
		$(this).valid();
	});
	
	$(".show").click(function() {
		$(".hidePrice").toggle();
		$(".hidePrice").toggleClass("active");
		$(".icon-show-all").toggle();
	});
	
	$(".btn-show-priceDetails").click(function() {
		$(this).toggleClass("active");
		$(".grand-total").toggleClass("active");
	});
	
	//tablette frontlardan farklı olarak bu satır var. mobil sitede mask ancak bu sekilde calısıyor. deniz
	$(".expDate, .issueDate, .adultDatePicker, .datepicker").mask("00.00.0000", {placeholder: "__.__.____"});
	
	$('[name=pan1], [name=pan2], [name=pan3], [name=pan4]').autotab_magic().autotab_filter('numeric');
	
	$("#3dsecureDiv").dialog({
		modal : true,
		autoOpen : false,
		height : '750',
		width : '650',
		draggable : true,
		resizeable : true,
		title :  FmtMessage.getMessage('js.3dSecureWindow.title'),
		resize : function(event, ui) {
			resizeIframe($(this));
		},
		open : function(event, ui) {
			resizeIframe($(this));
		}
	});
	
	$("#3dsecureDiv").on('dialogclose', function(event) {
		 $(".payDetailButtons").show();
	});
	
	$(".withCoupon").hide();
	$(".withoutCoupon").hide();
	 
	$('#couponreservationfail').hide();
	 
	$(".couponRow").click(function() {
		$(".withoutCoupon").show();
		$(".couponRow").css('display', 'none');
		$(".couponRowClose").css('display', 'inline-block');
	});
	
	$(".couponRowClose").click(function() {
		$(".withoutCoupon").hide();
		$(".couponRowClose").css('display', 'none');
		$(".couponRow").css('display', 'inline-block');
		$('#bankprocessfail').html('');
		$('#bankprocessfail').hide();
		$("#couponCodeId").val("");
		$('#couponCode').val("");
	 });
		
	$("#coupons").change(function () {
		var code = $(this).val();
		if(code != null){ 
			$('#couponCode').val(code);
		}else{
			$('#couponCode').val();
		} 
        
	}).trigger('change');
	
	//Favorite Passengers
	if(!CommonPayment.userAnonym && !CommonPayment.passengers) {
		getUserPassengers();
	}
	
	
	$('body').click(function(event) {
	    if (!$(event.target).closest('.favPassCheck').length) {
	        $('.favPassCheck').hide();
	    }
	}); 
	
	$(document).on("click",".btn-fav",function() {
		var index = getIndex($(this));
		var personType = getPersonType($(this));
		toggleFavoritePassList(personType, index);
		
		if (!CommonPayment.userAnonym) {
			
			var passIndex = $(this).attr("index");
			var typeId = getPassengerTypeId($(this));
			var items = getItemsWithTypeId(CommonPayment.passengers, typeId);
			
			var type = $(this).closest('tr').attr('personType');
			var html = "";
			html +='<option class="pop-close pop-title"><button type="button" class="btn btn-info btn-link pop-btn-ok" index=' + passIndex + '><span class="glyphicon glyphicon-remove" aria-hidden="true"></button></option>';
			items.forEach(function(item, index){
				html += '<option index=' + passIndex + ' data-index="' + index + '">';
				html += item.name + " " + item.surname + " " + item.birthdate;
				html += '</option>';
			});
			$(".favPassCheck").html(html);
		}
		
		var breakPoint = window.matchMedia("(min-width: 768px)");
		if(breakPoint.matches){
			$(".select-chosen-" + personType + "-" + index).toggle();
		}
		
		$(".select-chosen-" + personType + "-" + index).on('chosen:ready', function () {
			$(".select-chosen" + personType + "-" + index).trigger("chosen:open");
			
		}).chosen({
			max_selected_options:1,
			allow_single_deselect:true,
			width:"100%" 
		}).change(function(){
			$(".favPassCheck").chosen("destroy").css("display","none");
		});
	});
	
	$(document).on("click",".pop-btn-ok",function(){		
		var index = getIndex($(this));
		var personType = getPersonType($(this));
		toggleFavoritePassList(personType, index);
	});
	
	$('.favPassCheck').change(function(){	
		var data_index = $(this).find('option:selected').attr("data-index");
		var index = getIndex($(this));
		var personType = getPersonType($(this));

		//filter the passengers according to adult child..
		var typeId = getPassengerTypeId($(this));
		var items = getItemsWithTypeId(CommonPayment.passengers, typeId);
		var item = items[data_index];
		
		
		var row = $(this).closest("tbody").children("tr").filter(function(){
			 return $(this).attr("index") == index && $(this).attr("personType") == personType;
		})
		
		if(CommonPayment.serviceType === 'transfer'){
			row = $(this).closest("div").parent().parent();
		}
		setUserPassengers(item, row);
		toggleFavoritePassList(personType, index);
	});
	
	
	//End Favorite Passengers

	//Passengers Autocomplete
	if (!CommonPayment.userAnonym) {
		$("[inputType]:text").autocomplete({

			source : function(request, response) {

				var startsWith = request.term;
				CommonPayment.personInput = this.element;
				
				var typeId= getPassengerTypeId(CommonPayment.personInput);
				var inputType = $(CommonPayment.personInput).attr("inputType");
				var itemsStartsWithName = getItemsStartsWithName(CommonPayment.passengers, inputType, startsWith, typeId);
				response(itemsStartsWithName);

			},

			select : function(event, ui) {
				
				var index = getIndex($(CommonPayment.personInput));
				//$(CommonPayment.personInput).closest("tr").attr("index");
				var personType = getPersonType($(this));
				//$(CommonPayment.personInput).closest("tr").attr("personType");
				
				var row = $(this).closest("tbody").children("tr").filter(function(){
					 return $(this).attr("index") == index && $(this).attr("personType") == personType;
				})
				
				if(CommonPayment.serviceType === 'transfer'){
					row = $(this).closest("div").parent().parent();
				}
				
				setUserPassengers(ui.item, row);
				return false;
			},

			minLength : 1

		});
	}
	//end Passengers Autocomplete
	
	
	$('[name=3dsecureFrame]').load(function(event) {
		// alert('iframe load');
		window.clearTimeout(CommonPayment.timeout);
	});
	
	//UIERRORS
	if(CommonPayment.metasearch || CommonPayment.source > 0){
		UIErrorsInit();
	}
	
	//START BANK INSTALLMENT
	
	var bId = false;
	var bCode = false;
	if(typeof defaultInstBankId !== 'undefined'){
		bId = defaultInstBankId;
	}
	if(typeof defaultInstBankCode !== 'undefined'){
		bCode = defaultInstBankCode;
	}
	
	changeInstallmentBank(bId, bCode);
	
	$( "#installmentModal" ).dialog({
		autoOpen: false,
		height: "auto",
		width: 900,
		modal: true,
		open: function(){
	        $('.ui-widget-overlay').bind('click',function(){
	            $("#installmentModal").dialog('close');
	        })
	    }
    });
	
    $( "#showInstModal" ).on( "click", function() {
		$( "#installmentModal" ).dialog( "open" );
    });
	
    if(typeof serviceTypeForInstallment !== 'undefined') {
    		CommonPayment.serviceType = serviceTypeForInstallment;
    }

	if(typeof serviceTypeForNoTRSite !== 'undefined') {
		CommonPayment.serviceTypeForNoTRSite = serviceTypeForNoTRSite;
	}
	
	$("#paymentSelCurrency").change(function() {
		var value = $(this).val();
		var cardNum = $('.ccnumber').val();

		var installmentId = $('option:selected', this).attr('installmentId');

		$('#installmentId').val(installmentId);

		if(CommonPayment.serviceType) {
			getInstallmentsWithVposBin(cardNum, value, true)
		}else{
			getVposBin(cardNum, value);
		}
	});
		
	if($("#paymentSelCurrency").length > 0){
		$("#paymentSelCurrency").change();
	}
		
	$(".ccnumber").on('input', function(e){	
		var value = $(this).val();
		getInstallmentAndVpos(value);
		
			
	});
	
	//END BANK INSTALLMENT
});


function reloadPaymentTab(index){
	$( "#payment-tabs" ).tabs({ active: -1});
	$( "#payment-tabs" ).tabs({ active: index});
}


function reloadPaymentTabOnInit(){	
	if(CommonPayment.isNeedCreditCard)
		return;
	
	if(CommonPayment.hasAlternativePayment){
		//#payment-tabs
		var activeTabIndex = 0;
		$(".btnAlternativePayment").each(function (index, value) {			
			var installmentCurr = $(this).data("installmentcurrency");
			if(installmentCurr == CommonPayment.totalCurrency){
				var tabId = $(this).closest('.ui-tabs-panel').attr('id');
				var tab = $("li[aria-controls='"+tabId+"']" );
				var index = $('#payment-tabs ul li').index($("[aria-controls='"+tabId+"']" ));
				//var tab = $("li[aria-controls='"+tabId+""']" );
				activeTabIndex = index;
			}				
		});			
	} 
	
	reloadPaymentTab(activeTabIndex);
}

function getInstallmentAndVpos(value, forceRetry){
	if(forceRetry == undefined)
		forceRetry = false;

	value = value.split(' ').join('');//remove mask space			
	var currency = $('#paymentSelCurrency').val();
	if(typeof currency !== 'undefined' && !currency){
		currency = currencyForInstallment;
	}

	if(CommonPayment.serviceType) {
		getInstallmentsWithVposBin(value, currency, forceRetry);
	}else{
		getVposBin(value,currency);
	}
}


function getUserPassengers(){
	$.ajax({
		url : "/jpassengerList",
		dataType : "json",
		success : function(data) {
			if(data){
				CommonPayment.passengers = data.passengers;
			}else{
				hideFavoritePassengersDiv();
			}
		},
		fail:function(error){
			hideFavoritePassengersDiv();
		}
	
	});
}

function setUserPassengers(item, $tr) {
//	$tr.find("[inputType=gender]").val(item.gender);
	$tr.find("[inputType=gender][value="+(item.gender == 2 ? 2 : 1) + "]").prop("checked", true);
	$tr.find("[inputType=name]").val(item.name);
	$tr.find("[inputType=surname]").val(item.surname);
	$tr.find("[inputType=birthdate]").val(item.birthdate);
	$tr.find("[inputType=day]").val(parseInt(item.birthdate.split(".")[0]));
	$tr.find("[inputType=month]").val(item.birthdate.split(".")[1]);
	$tr.find("[inputType=year]").val(item.birthdate.split(".")[2]);
	$tr.find("[itype=idno]").val(item.idno);
	$tr.find("[itype=passNo]").val(item.passSerial+item.passNo);
	$tr.find("[itype=passIssueDate]").val(item.passIssueDate);
	$tr.find("[itype=passExpireDate]").val(item.passEndDate);
	$tr.find("[inputType=pday]").val(item.passEndDate.split(".")[0]);
	$tr.find("[inputType=pmonth]").val(item.passEndDate.split(".")[1]);
	$tr.find("[inputType=pyear]").val(item.passEndDate.split(".")[2]);
	var oDropdownElement = $tr.find(".passCitizenshipCountryAttr");

	if(oDropdownElement.length > 0) {
        var oDropdown = oDropdownElement.msDropdown().data("dd");
        oDropdown.setIndexByValue(item.citizenshipCountry);
    }

    $tr.find("[inputType=passIssueCountry]").val(item.issueCountry);
}

function hideFavoritePassengersDiv(){
	$(".fav-pass").hide();
}

function toggleFavoritePassList(personType, index){
	$('#favPassCheckUl_' + personType +'_'+ index).toggle();
}

function getPassengerTypeId($row){
	var type = $row.closest('tr').attr('personType');
	if(!type) {
		type = $row.closest("div").parent().parent().attr("personType");
	}

	if (type == 'adult')
		return 3;
	else if (type == 'child')
		return 2;
	else
		return 1;
}
function getIndex($row) {
	var index = $row.closest("tr").attr("index");

	if(!index) {
		index = $row.closest("div").parent().parent().attr('index');
	} 
	return index;
}
function getPersonType($row) {
	var personType = $row.closest("tr").attr("personType");
	
	if(!personType) {
		personType = $row.closest("div").parent().parent().attr("personType");
	}
	return personType;
}

function UIErrorsInit(){
	//UI ERRRORS
	
		var pageStartDate = getNowTime();
		var myEvent = window.attachEvent || window.addEventListener;
		var chkevent = window.attachEvent ? 'onunload' : 'unload'; /// make IE7, IE8 compitable
		myEvent(chkevent, function(e) { // For >=IE7, Chrome, Firefox
			var nowTime = getNowTime();
			CommonPayment.uiErrors.push({elementName: "close", warningText: "", userInput: "", errorType: 2, errorDate: nowTime});
			CommonPayment.uiEvents.push({elementName: 'page', startDate: pageStartDate, endDate: nowTime, eventType: 2});
			submitUiErrors();
			(e || window.event).returnValue = false;
			return false;
		});
		$('input[type=text][name], input[type=radio][name], input[type=checkbox][name], input[type=button][name]:not(.finalButton), select[name]').focusin(function(){
			var elementName = ($(this).attr('id') ? $(this).attr('id') : $(this).attr('name'));
			var startDate = getNowTime();
			$(this).focusout(function(){
				var userInput = $(this).val();
				if($(this).is('input[type=checkbox]')){
					userInput = $(this).is(':checked') ? 'on' : 'off';
				}
				if(elementName.indexOf('pan') == 0){
                    userInput = userInput.replace(/\d/g,'*');
                }
				var uiEvent = {elementName: elementName, startDate: startDate, endDate: getNowTime(), userInput: userInput, eventType: 1};
				if (CommonPayment.uiEvents.filter(function(e){return(e.elementName==uiEvent.elementName&&e.startDate==uiEvent.startDate&&e.endDate==uiEvent.endDate);}).length == 0) {
					CommonPayment.uiEvents.push(uiEvent);
				}
				$(this).off( "focusout" )
			});
		});
		$('#payment-tabs a').click(function(){
			var elementName = ($(this).attr('id') ? $(this).attr('id') : $(this).attr('name'));
			if(elementName){
				var nowTime = getNowTime();
				var uiEvent = {elementName: elementName, startDate: nowTime, endDate: nowTime, eventType: 1};
				if (CommonPayment.uiEvents.filter(function(e){return(e.elementName==uiEvent.elementName&&e.startDate==uiEvent.startDate&&e.endDate==uiEvent.endDate);}).length == 0) {
					CommonPayment.uiEvents.push(uiEvent);
				}
			}
		});
		$('a[href]:not(#payment-tabs a):not([href="javascript:void(0)"],[href="javascript:void(0);"],[href="#"])').click(function(){
			var elementName = $(this).attr('href');
			elementName = elementName.indexOf('#') == 0 ? elementName.replace(/#/,'') : elementName;
			elementName = elementName.indexOf('http://') == 0 || elementName.indexOf('https://') == 0 ? elementName.replace(/(https:\/\/|http:\/\/)/,'') : elementName;
			elementName = elementName.replace(/www./g,'');
			if( elementName.indexOf('/') == 0 || elementName.indexOf('a/') == 0){
				elementName = elementName.replace(/(\/a\/|a\/)/,'');
			}else{
				elementName = elementName.indexOf('/') == 0 ? elementName.split('/')[1] : elementName.split('/')[0];
			}
			if(elementName){
				var nowTime = getNowTime();
				var uiEvent = {elementName: elementName, startDate: nowTime, endDate: nowTime, eventType: 1};
				if (CommonPayment.uiEvents.filter(function(e){return(e.elementName==uiEvent.elementName&&e.startDate==uiEvent.startDate&&e.endDate==uiEvent.endDate);}).length == 0) {
					CommonPayment.uiEvents.push(uiEvent);
				}
			}
		});
		$('.genderRadio').on('ifChecked', function(event){
			$(this).focus();
			var userInput = $(this).val();
			var elementName = ($(this).attr('id') ? $(this).attr('id') : $(this).attr('name'));
			var nowTime = getNowTime();
			var uiEvent = {elementName: elementName, startDate: nowTime, endDate: nowTime, userInput: userInput, eventType: 1};
			if (CommonPayment.uiEvents.filter(function(e){return(e.elementName==uiEvent.elementName&&e.startDate==uiEvent.startDate&&e.endDate==uiEvent.endDate);}).length == 0) {
				CommonPayment.uiEvents.push(uiEvent);
			}
		});
	//END UI ERRORS
}

//START BANK INSTALLMENT
function blockUnneccessaryVposCall(cardNum, forceRetry){
	return !forceRetry && !CommonPayment.retryVposBinRequest && cardNum.length < CommonPayment.creditCardNumberLength;
}
function getInstallmentsWithVposBin(cardNum, currency, forceRetry){
	//Ön yüzde kullanıcı direkt tüm kart numarasını yapıştırırsa diye 6 dan uzun olan numarayı kabul ediyoruz.
	if(cardNum && cardNum.length >= CommonPayment.creditCardFirstNumberCountToCheckVpos){
		if(blockUnneccessaryVposCall(cardNum, forceRetry)){
			return;
		}
		
		CommonPayment.retryVposBinRequest = false;

		var vposData = {
			ccBinNumber : cardNum,
			serviceType : CommonPayment.serviceType,
			amount: CommonPayment.totalAmount - CommonPayment.discountAmount,
			selectedCurrency: currency,
			source: CommonPayment.source,
			officeId: $('#officeId').val()
		};

		if (CommonPayment.serviceType == 'flight'){
			vposData.depItineraryId = $("#depItineraryId").val();
			vposData.retItineraryId = $("#retItineraryId").val();
			vposData.orderId = $("#orderId").val();
		}

		$.ajax({
			url : "/getVposByBin",
			dataType : "html",
			data : vposData,
			success : function(data) {
				if(data){
                    resetInstallment();
                    resetInstallmentForTabs();

					$("#taksit").html(data);

                    changeInstallmentLocationByTab();

				} else {
					CommonPayment.retryVposBinRequest = true;
					$("#taksit").html('');
				}
			},
			error : function(err){
				CommonPayment.retryVposBinRequest = true;
				$("#taksit").html('');
			}
		});
	} else {
		CommonPayment.retryVposBinRequest = true;
		$("#taksit").html('');
		resetInstallment();		
	}
}

function resetInstallmentForTabs() {

    if($('#masterpassInstalmentsDiv').find('#taksit').html() != undefined){
        $('#creditCardInstalmentsDiv').html($('#masterpassInstalmentsDiv').html());
        $('#masterpassInstalmentsDiv').html('');
        $('#taksit').html('')
    }
}

function changeInstallmentLocationByTab() {

    if (SELECTED_TAB == "cc-noinstallment-tab-li"){
        $('#masterpassInstalmentsDiv').html('');
    }
    else if(SELECTED_TAB == "masterpass-tab"){
        $('#masterpassInstalmentsDiv').html($('#creditCardInstalmentsDiv').html());
        $('#creditCardInstalmentsDiv').html('');
        $('[name=installmentIdRadio]').first().prop('checked', true);
        $('[name=installmentIdRadio]:checked').change();
    }
}

function changeInstallmentBank(bankId, bankCode, brandType){
	if(!bankId) return;

	if(bankCode){
		showCardImageInCreditCard(bankCode);
	}
	if(brandType){
		showCardBrandImageInCreditCard(brandType);
	}
	
	$('#vpid').val(bankId);	
	$('[name=installmentIdRadio]').first().prop('checked', true);
	$('[name=installmentIdRadio]:checked').change();
}

function getVposBin(cardNum, currency){
	//Ön yüzde kullanıcı direkt tüm kart numarasını yapıştırırsa diye 6 dan uzun olan numarayı kabul ediyoruz.
	if(cardNum && cardNum.length >= CommonPayment.creditCardFirstNumberCountToCheckVpos){


		var vposData = {
			ccBinNumber : cardNum,
			serviceType : CommonPayment.serviceTypeForNoTRSite,
			amount: CommonPayment.totalAmount - CommonPayment.discountAmount,
			selectedCurrency: currency,
			source: CommonPayment.source,
			officeId: $('#officeId').val()
		};

		if (CommonPayment.serviceTypeForNoTRSite == 'flight'){
			vposData.depItineraryId = $("#depItineraryId").val();
			vposData.retItineraryId = $("#retItineraryId").val();
			vposData.orderId = $("#orderId").val();
		}

		$.ajax({
			type : "POST",
			url : "/getVposFreePayment",
			async : false,
			dataType : "json",
			data : vposData,
			success : function(data) {
				updateTotalPriceDiv(data);
				clearVPOSRuleInfoMessages();
				if(data.bankCode){
					showCardImageInCreditCard(data.bankCode);
				}else{
					hideCardImageInCreditCard();
				}
				if(data.brandType){
					showCardBrandImageInCreditCard(data.brandType);
				}else{
					hideCardTypeImageInCreditCard();
				}
				
				if(data.paymentOptionInfos){
					showVPOSRuleInfoMessages(data.paymentOptionInfos.messages);
				}
			},
			error : function(err){
				hideCardImageInCreditCard();
				hideCardTypeImageInCreditCard();
				cleanTotalPriceDiv();
			}
		});
	}else{
		hideCardImageInCreditCard();
		hideCardTypeImageInCreditCard();
		cleanTotalPriceDiv();
	}
}


function cleanTotalPriceDiv(){
	$("#paymentTotalDiv").html("");
}

function updateTotalPriceDiv(data){
	var html = "";
	if(data.originalCurrency != data.paymentCurrency){
		html += '<div class="priceIns">' + data.payPriceWarning + '<div class="priceIns">' + data.originalCurrencyWarning + '</div>';
	}else{
		html += '<div class="priceIns">' + data.payPriceWarning + '</div>';
	}
		
	$("#paymentTotalDiv").html(html);
	
}

function showCardImageInCreditCard(bankCode){
	if(bankCode){
		$('div.credit-card #cardBrandImg').attr("src", "/images/kartlar/"+bankCode+".png");
		var altMsg = $('input[type=hidden]#cardname_'+bankCode.toUpperCase()).val();
		$('div.credit-card #cardBrandImg').attr("alt", altMsg);
		$('div.credit-card #cardBrandImg').show();
	}
}

function showCardBrandImageInCreditCard(brandType){
	if(brandType){
		$('div.credit-card #cardTypeImg').attr("src", "/images/kartlar/"+brandType.toLowerCase()+".png");
		var altMsg= brandType.toUpperCase();
		$('div.credit-card #cardTypeImg').attr("alt", altMsg);
		$('div.credit-card #cardTypeImg').show();
	}
}

function hideCardImageInCreditCard(){
	$('div.credit-card #cardBrandImg').hide();
}

function hideCardTypeImageInCreditCard(){
	$('div.credit-card #cardTypeImg').hide();
}

function showAllInstallment() {
	$(".installmentradio").parent().parent().show();
	$(".trInstallment").removeClass("taksitChange");
}

//Reset installment to initial state.
function resetInstallment(){
	$(".installmentTable").hide();
	$("tr.installmentInfo").removeClass("selected");
	$(".installmentradio").parent().parent().show();
	$(".trInstallment").removeClass("taksitChange");
	var lastPrice = $("tr.installmentInfo span.instalmentOnlyAmount").first().html();
	$("p.total").html(lastPrice);
	
	hideCardImageInCreditCard();
	hideCardTypeImageInCreditCard();
}
//END BANK INSTALLMENT

function resizeIframe($dialog) {
	$dialog.find('iframe').height($dialog.height() - $dialog.find('div:first').outerHeight(true) - 10).width('100%');
}

function getItemsWithTypeId(items, typeId) {
	
	var itemsWithId=items;

	itemsWithId = $.map(items, function(item) {

			if (typeId == item["type"] || item["type"] == 0 ) {
				item.label = item.name + " " + item.surname + " " + item.birthdate;
				return item;
			}

			return null;
		});

	return itemsWithId;
}


function getItemsStartsWithName(items, prop, startsWith, typeId) {
	
	var itemsStartsWithName = items;
	if(startsWith) {
		startsWith = startsWith.toLowerCase();
		var underScore = startsWith.indexOf("_");

		if (underScore > 0)
			startsWith = startsWith.substring(0, startsWith.indexOf("_"));

		itemsStartsWithName = $.map(items, function(item) {

			var itemProp = item[prop].toLowerCase();

			if (itemProp.indexOf(startsWith) == 0 && typeId == item["type"]) {
				item.label = item.name + " " + item.surname + " " + item.birthdate;
				return item;
			}

			return null;
		});
	}

	return itemsStartsWithName;
}

function showAgreement(url) {
	var urlA="";
	if(url=='flight'){
		urlA = "/agreement";
	}else if(url=='hotel'){
		urlA = "/hotelAgreement?guid="+$('#guid').val();
	}else if(url=='bus'){
		urlA = "/bus/agreement";
	}else if(url=='transfer'){
		urlA = "/transferAgreement";
	}else if(url=='tour'){
		urlA = "/tourAgreement?guid="+$('#guid').val();
	}else if(url=='insurance'){
		urlA = "/insurance/agreement";
	}else if(url=='sbus'){
		urlA = "/sbusAgreement";
	}else if(url=='house'){
		urlA = "/house/agreement?guid="+$('#guid').val();
	}
	else if(url=='yacht'){
		urlA = "/yacht/agreement?guid="+$('#guid').val();
	}
	
	$('<div title="' + FmtMessage.getMessage('js.general.agrement') + '"></div>').load(urlA).dialog({
		width : 800,
		height : 600,
		modal : true,
		resizable : false,
		draggable : false
	});
}

function showPrivacyPolicy(url) {
	var urlP="";
	if(url=='flight'){
		urlP = "/privacyPolicy";
	}else if(url=='hotel'){
		urlP = "/hotelPrivacy";
	}else if(url=='bus'){
		urlP = "/bus/privacy";
	}else if(url=='transfer'){
		urlP = "/transferPrivacy";
	}else if(url=='tour'){
		urlP = "/tourPrivacy";
	}else if(url=='insurance'){
		urlP = "/insurance/privacyPolicy";
	}else if(url=='sbus'){
		urlP = "/sbusPolicy";
	}else if(url=='house'){
		urlP = "/house/privacyPolicy";
	}
	else if(url=='yacht'){
		urlP = "/yacht/privacyPolicy";
	}
	$('<div title="' + FmtMessage.getMessage('js.general.privacyPolicy')+ '"></div>').load(urlP).dialog({
		width : 800,
		height : 600,
		modal : true,
		resizable : false,
		draggable : false
	});
}

function bkmCallbackFunction(message) {
    $.ajax({
        type: "POST",
        async: true,
        url: (message.isSuccess ? CommonPayment.bkmSuccessUrl : CommonPayment.bkmFailUrl),
        success: function (response) {
            $("#bkmexpressResponse").html(response);
            $("#bkmexpressResponse").find("script").each(function () {
                eval($(this).text());
            });
        }
    });
}

function saveReservationAjax(vUrl,vForm,vUrlF) {
	$.ajax({
		type : "POST",
		async : true,
		url : vUrl, 
		data : $(vForm).serialize(),
		dataType : 'json',
		success : function(response) {
			
			if (response.hasError) {
				closeLoaderBox();
				showBankProcessMsg(response.errorMessage + "<br /><br /> " + response.errorCode, false);
				return;
			}

			try {

				CommonPayment.use3DSecure = response.use3DSecure;
				CommonPayment.useIFrameWhen3D =response.useIFrameWhen3D;

                CommonPayment.useBkm = response.useBkm;
				
				var urlF = vUrlF;
				
				if(!CommonPayment.useIFrameWhen3D && CommonPayment.use3DSecure) {
					$.ajax({
						type : "POST",
						async : false,
						url : urlF,
						success : function(msg) {
							if(msg){
									try{
										var el = $("#withoutIFrameForm");
										el.html(msg);
									}catch (e) {
								}
							}
						},
						error : function(xhr, ajaxOptions, errorThrown) {
							closeLoaderBox();
						}
						
					});
				}
                else if(CommonPayment.useBkm){
                    var containerDiv = $("#bkmexpressContainer");
                    containerDiv.html(response.bkm.bkmPage);
                    CommonPayment.bkmSuccessUrl = response.bkm.successPage;
                    CommonPayment.bkmFailUrl = response.bkm.failPage;

                    //Wait for loading bex.js
                    setTimeout(function(){
                        closeLoaderBox();
                        bkmInitFunction();
                    },3000);
                }
                else if (!CommonPayment.use3DSecure) {
					if(siteId == 2 || siteId == 11){
						urlF = urlF + '&' + getUrlBrowserParameters();
					}
					$("[name=3dsecureFrameVpos]").attr('id', new Date().getTime());
					$("[name=3dsecureFrameVpos]").attr('src', urlF);
				} else {
					closeLoaderBox();
					$("[name=3dsecureFrame]").attr('id', new Date().getTime());
					$("[name=3dsecureFrame]").attr('src', urlF);
					$('#bankprocess').show();

					var modalDiv = $("#3dsecureDiv");
					modalDiv.dialog("option", "width", 600);
					modalDiv.dialog("open");
					
					CommonPayment.timeout = window.setTimeout(function(){
					}, 120000);

				}

			} catch (e) {
			}
		},
		error : function(xhr, ajaxOptions, errorThrown) {
			closeLoaderBox();
		}

	});
}


function addThousandSeperator(number){
	var str = String(number);
	str = str.replace('.',',');
	
    var re = /(\d+)(\d{3})/;
    return str.replace(/^\d+/, function(w){
        while(re.test(w)){
            w= w.replace(re, '$1.$2');
        }
        return w;
    });
}

function checkAgreementStatus(){
	var agree = $('#agree').prop("checked");
	
 	if ($('agreeExpedia').length > 0) {
 		agree = agree && $('#agreeExpedia').prop("checked");
 	}
 	
	if (agree) {
		return true;
	}else{
		return false;
	}
}

function checkMasterpassStatus(){
    var isCardSelected = $("[name=cardlistcheckbox]").is(":checked") || false;
    var isNewCard = $("#addAndPayWithNewCard").prop("checked") || false;
	var agree = $('#addMasterpass').prop("checked") || false;

	return isCardSelected ? true : isNewCard && agree;
	//return agree;
}

function checkMasterpassPhoneStatus(){
    var masterpassGsm = $("[name=masterpassGsm]").val();
    return masterpassGsm != null && masterpassGsm.length != "";
}

function bankInstallmentChanged(bId, iid){
	$('#vpid').val(bId);
	$('#installmentId').val(iid);
	$('[name=3dsecureFrame]').contents().find('#iid').val(iid);
	$('[name=3dsecureFrame]').contents().find('#cformbid').val(bId);
}

function formSubmiting() {
	$('#taksit').hide();
	$('#bankSelection').hide();
	$('#bankprocess').show();
	$('#bankprocessfail').hide();
	$('#autoreserve').hide();
}

function clearCCInfo() {
	$("#pan").val("");
    $("#pan1").val("");
	$("#pan2").val("");
	$("#pan3").val("");
	$("#pan4").val("");
	$("#cc_owner_surname").val("");
	$("#cc_owner_name").val("");
	$("#cc_expire_month").val(0);
	$("#cc_expire_year").val(0);
	$("#cv2").val("");

}
function clearMasterpassCCInfoAndPaymentForm(){
	$("#masterpass_cardname").val("")
	$("#masterpassGsm").val("")
    $("#masterpass_cv2").val("");
    $("#masterpass_pan").val("");
    $("#masterpass_cc_owner_name").val("");
    $("#masterpass_cc_expire_month").val(0);
    $("#masterpass_cc_expire_year").val(0);
    $('#addMasterpass').prop("checked", false);
    $("#addMasterpass").prop("checked", false)
}

function showBankProcessMsg(msg, success){
	$('#bankprocessfail').html(msg);
	if(success){
		$('#bankprocessfail').removeClass('cc-error');
		$('#bankprocessfail').addClass('alert-success');
	}else{
		$(".payDetailButtons").show();
		$('html, body').animate({
			scrollTop: $('#bankprocessfail').offset().top
		}, 500);
		
		var nowTime = getNowTime();
		CommonPayment.uiErrors.push({elementName: "ticket_error", warningText: msg, userInput: "", errorType: 1, errorDate: nowTime});
		CommonPayment.uiEvents.push({elementName: 'ticket_error', startDate: nowTime, endDate: nowTime, eventType: 1});
	}
	$('#bankprocessfail').show();
	
}

function paymentFailedWithMsg(msg, autoreservation) {
	
	window.clearTimeout(CommonPayment.timeout);

	if (!CommonPayment.use3DSecure) {
		closeLoaderBox();
		try {
			$('[name=3dsecureFrameVpos]').attr('src', 'about:blank');
			$("[name=3dsecureFrameVpos]").contents().find("head").html('');
			$("[name=3dsecureFrameVpos]").contents().find("body").html('');
		} catch (e) {
		}
	} else {
		$('#bankprocess').hide();

		var modalDiv = $("#3dsecureDiv");
		modalDiv.dialog("close");
		try {
			$('[name=3dsecureFrame]').attr('src', 'about:blank');
			$("[name=3dsecureFrame]").contents().find("head").html('');
			$("[name=3dsecureFrame]").contents().find("body").html('');
		} catch (e) {
		}
	}


	var bankErrorMessage = FmtMessage.getMessage('js.bank.payment.fail') + '<br /><br /> ' + msg;

	showBankProcessMsg(bankErrorMessage, false);
	
	if(autoreservation != null && autoreservation != ""){
		var url =  URL_MAPPING.resolveUrl('/orders');
		$("#autoreserve").html(FmtMessage.getMessage('js.autoreserve.reserved.warning').replace('{0}', url));
		$('#autoreserve').show();
		
		setPassengersFormReadyOnly();
	}else{
		$('#autoreserve').hide();
	}
	var url = URL_MAPPING.resolveUrl('/common/error');

    $.post(url, { userAgent : window.navigator.userAgent, msg: bankErrorMessage });
}

function setPassengersFormReadyOnly() {
	$("#FormTable :input, #FormTable .selected-flag").attr('readonly', 'readonly');
	$('#FormTable .genderRadio').iCheck('disable');
	$("#FormTable .phone").unmask();
}

function setFormReadyOnly(form) {

	$("#" + form + " :input").attr('readonly', 'readonly');
	$("#" + form + " select").attr("disabled", true);
	$("#" + form + " :input[type='checkbox']", "#" + form + " :input[type='radio']").attr("disabled", true);
	$("#gsm, #phone").unmask();
	$(".datepicker").datepicker('destroy');

}

function getNowTime(){
	try {
		var nowDate = new Date();
	    var year    = nowDate.getUTCFullYear();
	    var month   = nowDate.getUTCMonth() + 1; // getMonth() is zero-indexed, so we'll increment to get the correct month number
	    var day     = nowDate.getUTCDate();
	    var hours   = nowDate.getUTCHours();
	    var minutes = nowDate.getUTCMinutes();
	    var seconds = nowDate.getUTCSeconds();
	    
	    month   = (month < 10) ? '0' + month : month;
	    day     = (day < 10) ? '0' + day : day;
	    hours   = (hours < 10) ? '0' + hours : hours;
	    minutes = (minutes < 10) ? '0' + minutes : minutes;
	    seconds = (seconds < 10) ? '0' + seconds: seconds;
	         
	    return day + '/' + month + '/' + year  + ', ' + hours + ':' + minutes + ':' + seconds; // dd/MM/yyyy, HH:mm:ss  
	    
//		return (new Date()).toLocaleString('en-GB', { timeZone: 'Europe/Istanbul' }); // dd/MM/yyyy, HH:mm:ss  
	} catch (e) {
	}
	return null;
}


function setCoupon(couponCode){
	if(couponCode) {
		$(".couponRow").trigger("click");
		$("#couponCode").val(couponCode);
		
		addCouponFlight();
	}
}

function copyCouponCode(couponCode){
	$('#couponCode').val(couponCode);
};

// Check Coupon
function addCouponFlight()
{
	addCoupon('flight');
}

function isServiceTypeFlight(vServiceType){
	if(vServiceType)
		return 'flight' == vServiceType;
	return false;
}

function addCoupon(vServiceType) {
	var depBrand = null;
	var retBrand = null;
	
	//flight has branded fares. Only for serviceType  = 'flight'
	if($(".fare-item.selected").length){
		$(".fare-item.selected").each(function(){ 
			if($(this).attr('flightindex') == 0) //departureFlight
				depBrand = $(this).attr('priceKey');
			if($(this).attr('flightindex') == 1) //returnFlight
				retBrand = $(this).attr('priceKey');
		});
	}
	$(".couponRowClose").hide();
		
	$.ajax({
		url : '/coupon/check',
		dataType : "json",
		type : 'POST',
		data : {serviceType: vServiceType,
				guid: $('#guid').val(),
				code: $('#couponCode').val(),
				itinarary: $("#itinId").val(),
				itinarary_return: $("#itinId_return").val(),
				priceDetailKey : $("#priceDetailKey").val(),
				source: $('#source').val(),
				depBrand: depBrand,
				retBrand: retBrand
				
		},
		success : function(data) {
			var campaignPopupCallback = null;
			// if(isServiceTypeFlight(vServiceType)) {
			campaignPopupCallback = POPUP.campaignCallback();
			// }
			if(data.hasError){

				$('#bankprocessfail').html(data.errorMessage);
				$('#bankprocessfail').show();
				$(".payDetailButtons").show();
				$(".couponRowClose").show();
				
				if(campaignPopupCallback)
					campaignPopupCallback.showCouponFailMessage();
				
				return;

			}else{
				if(data.checkStatus > 0){
					if(campaignPopupCallback)
						campaignPopupCallback.showCouponFailMessage();

					var errorMessage = '';
					if(data.checkStatus == 1){
						errorMessage = FmtMessage.getMessage('js.error.coupon.code.notfound');
					}else if(data.checkStatus == 2){
						errorMessage = FmtMessage.getMessage('js.error.coupon.code.used');
					}else if(data.checkStatus == 3){
						errorMessage = FmtMessage.getMessage('js.error.coupon.code.datenotvalid');
					}else if(data.checkStatus == 4){
						errorMessage = FmtMessage.getMessage('js.error.coupon.code.allocated');
					}else{
						errorMessage = FmtMessage.getMessage('js.error.coupon.other');
					}
					
					$('#bankprocessfail').html(errorMessage);
					$('#bankprocessfail').show();
					$(".payDetailButtons").show();
					$(".couponRowClose").show();
				}else if(data.discountType < 3){ 
					
					$('#bankprocessfail').html('');
					$('#bankprocessfail').hide();
	
					$(".withoutCoupon").hide();
					$(".withCoupon").show();
					
					var couponContent;
					CommonPayment.discountAmount = data.priceDiscountAmount;
					
					var message;

					var currentTotal = CommonPayment.totalAmount;
					if (CommonPayment.preventCouponUse) {
						message = '<fmt:message key="bus.coupon.cannot.use.warning" ><fmt:param>${searchDetail.companyName}</fmt:param></fmt:message>';
						message = message.replace("<price>", CommonPayment.discountAmount);
						message = message.replace("<currency>", data.currency);
						
						couponContent = couponContent + '<td class="couponInfo couponmsg ">' + message + '</td>';
						couponContent = couponContent + '<td class="couponmsg">  <fmt:message key="reservation.withCoupon.bus.card" /> <b style="color:orange;">'+ CommonPayment.totalAmount +' TL</b></td>';
						
						$(".titles").hide();
					}else {

						if(campaignPopupCallback)
							campaignPopupCallback.showCouponSuccessMessage();
						
						currentTotal = CommonPayment.totalAmount - CommonPayment.discountAmount;
						couponContent = couponContent + '<td class="couponInfo">'+data.code+'</td>';
						couponContent = couponContent + '<td class="couponInfo"> - '+ CommonPayment.discountAmount.toFixed(2) +'</td>	';
						couponContent = couponContent + '<td class="Toplam">  '+ currentTotal.toFixed(2) +' '+ CommonPayment.totalCurrency + '</td>';
						couponContent = couponContent + '<td class="deleteCoupon"> <a id="deleteCoupon" class="delete btn" onclick="deleteCoupon()">'+ FmtMessage.getMessage('js.button.coupon.delete') + '</a></td>';
						couponContent = couponContent + '<input type="hidden" id="coupon" name="couponDiscountAmount" value='+ CommonPayment.discountAmount +'" />';

					}
					
					$("#withCoupon").html(couponContent);
					 
					$("#couponCodeId").val(data.couponCodeId);
					
					updateInstallmentsWithCurrentTotal(currentTotal);
					updateAccountPaymentStatusWithCurrentAmount(currentTotal);
					
					var current_index = $("#payment-tabs").tabs("option","active");
					reloadPaymentTab(current_index);
 					$('.paymentOnlyTotalAmount').html(addThousandSeperator(parseFloat(currentTotal, 10).toFixed(2)));
 					$('.nestPayAmount').html(parseFloat(currentTotal, 10).toFixed(2) + " " + CommonPayment.totalCurrency);
				}
			}
			
			if($('#withCoupon').is(':visible')){
				$('#couponreservationfail').html(FmtMessage.getMessage('js.reservation.withCoupon.warning'));
				$('#couponreservationfail').show();
			}

		},
		error : function(xhr, ajaxOptions, errorThrown) {
			$('#bankprocessfail').html(FmtMessage.getMessage('js.error.coupon.code.notfound'));
			$('#bankprocessfail').show();
		}
	});
}

//Kupon kullanımında currentTotal discount uygulanmış halini tutar
function updateInstallmentsWithCurrentTotal(currentTotal) {
	$("tr.installmentInfo").each(function(){
	    var self = $(this);
	    var rateIns = Number(self.attr("rate"));
	    var numberIns = Number(self.attr("number"));
	    var currencyRate = Number(self.attr("currencyRate"));
	    if(!currencyRate){ //tüm kartların taksit seçenekleri gösterilirken boş olur
	    	currencyRate = 1.0;
	    }
	    numberIns = ((numberIns == 0) ? 1 : numberIns);
	    if(rateIns && numberIns && currencyRate){
		    var totalInsAmount =  currentTotal * rateIns * currencyRate;
		    var monthInsAmount =  totalInsAmount/numberIns;
		    var totalInsInterest = totalInsAmount - currentTotal;
		    self.find('.instalmentOnlyAmountMonth').html(addThousandSeperator(parseFloat(monthInsAmount, 10).toFixed(2)));
		    self.find('.instalmentOnlyInterest').html(addThousandSeperator(parseFloat(totalInsInterest, 10).toFixed(2)));
		    self.find('.instalmentOnlyAmount').html(addThousandSeperator(parseFloat(totalInsAmount, 10).toFixed(2)));
	    }
	});
	
	$('.installmentInfo.selected [name=installmentIdRadio]').change();
}


function deleteCoupon() {
	
	$('#discountAlert').hide();
	$(".couponRow").css('display', 'none');
	$(".withCoupon").hide();
	$("#withCoupon").html("");
	$(".withoutCoupon").show();
	$(".couponRowClose").show();
	$(".couponArrow").hide();
	$("#couponCodeId").val("");
	$('#couponCode').val("");
	
	$('#couponreservationfail').html('');
	$('#couponreservationfail').hide();
	
	$("#withoutCoupon").show();		
	
	$("tr.installmentInfo").each(function(){
	    var self = $(this);
	    var rateIns = Number(self.attr("rate"));
	    var numberIns = Number(self.attr("number"));

	    var currencyRate = Number(self.attr("currencyRate"));
	    if(!currencyRate){ //tüm kartların taksit seçenekleri gösterilirken boş olur
	    	currencyRate = 1.0;
	    }
	    
	    numberIns = ((numberIns == 0) ? 1 : numberIns);
	    if(rateIns && numberIns && currencyRate){
		    var totalInsAmount =  CommonPayment.totalAmount * rateIns * currencyRate;
		    var monthInsAmount =  totalInsAmount/numberIns;
		    self.find('.instalmentOnlyAmountMonth').html(addThousandSeperator(parseFloat(monthInsAmount, 10).toFixed(2)));
		    self.find('.instalmentOnlyAmount').html(addThousandSeperator(parseFloat(totalInsAmount, 10).toFixed(2)));
		    $('.installmentInfo.selected [name=installmentIdRadio]').change();
	    }
	});
	$('.paymentOnlyTotalAmount').html(addThousandSeperator(parseFloat(CommonPayment.totalAmount, 10).toFixed(2)));
	$('.nestPayAmount').html(parseFloat(CommonPayment.totalAmount, 10).toFixed(2) + " " + CommonPayment.totalCurrency);
	CommonPayment.discountAmount = 0.0;
	$("#coupons").val('');
	updateAccountPaymentStatusWithCurrentAmount(CommonPayment.totalAmount);
}

function markSaleConversion() {

	var google_conversion_id = 955290302;
	var google_conversion_language = "en";
	var google_conversion_format = "1";
	var google_conversion_color = "ffffff";
	var google_conversion_label = "D8unCNL9rQMQvqXCxwM";
	var ga = document.createElement('script');
	ga.type = 'text/javascript';
	ga.async = true;
	ga.src = ('https:' == document.location.protocol ? 'https://www.' : 'http://www.') + 'googleadservices.com/pagead/conversion.js';
	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(ga, s);
}

function getUrlBrowserParameters(){
	
	var theMoment = new Date();
	var theTimeZone= (theMoment.getTimezoneOffset());
	var theBrowserName = navigator.appName + ' ' + navigator.appVersion;
	
	var theScreenPixelDepth = '';
	
	if (theBrowserName != "Netscape") {
		theScreenPixelDepth = screen.colorDepth;
	} else {
		theScreenPixelDepth = screen.pixelDepth;
	}
	
	var theScreenRes = screen.width + 'x' + screen.height;
	var theBrowserCookie = navigator.cookieEnabled;
	var theBrowserJava = navigator.javaEnabled();
	var theBrowserPlatform = navigator.platform;
	
	var theBrowserStylesheets = '';
	var theBrowserLang = '';
	var theSystemLang = '';
	var theUserLang = '';
	var theProcessor = '';
	var theConnection = '';
	
	if (theBrowserName != "Netscape") {
		theBrowserStylesheets = navigator.cookieEnabled;
		theBrowserLang = navigator.browserLanguage;
		theSystemLang = navigator.systemLanguage;
		theUserLang = navigator.userLanguage;
		theProcessor = navigator.cpuClass;
		theConnection = navigator.connectionType;
	}
	var urlParams = 'afsPaymentId='+CommonPayment.afsPaymentId+'&theMoment='+theMoment+'&theTimeZone='+theTimeZone+'&theBrowserName='+theBrowserName+'&theScreenPixelDepth='+theScreenPixelDepth+'&theScreenRes='+theScreenRes;
	urlParams = urlParams+'&theBrowserCookie='+theBrowserCookie+'&theBrowserJava='+theBrowserJava+'&theBrowserPlatform='+theBrowserPlatform+'&theBrowserStylesheets='+theBrowserStylesheets;
	urlParams = urlParams+'&theBrowserLang='+theBrowserLang+'&theSystemLang='+theSystemLang+'&theUserLang='+theUserLang+'&theProcessor='+theProcessor+'&theConnection='+theConnection;
	
	return urlParams;
}

function submitUiErrors(){
	if(CommonPayment.uiErrors.length > 0 || CommonPayment.uiEvents.length > 0 ){
		$.ajax({
			type : "POST",
			async : false,
			url : "/uiErrors/submit",
			data : {"uiErrors" :''+JSON.stringify(CommonPayment.uiErrors).replace(/\'/g,"\\'").replace(/\"/g,"'")
				,"uiEvents": ''+JSON.stringify(CommonPayment.uiEvents).replace(/\'/g,"\\'").replace(/\"/g,"'")
				,"guid":$(':input[name=guid][type=hidden]').val()
				,"browserName":getBrowserNameAndInfo()
			},
			dataType : 'json',
			success : function(response) {
				CommonPayment.uiErrors = [];
				CommonPayment.uiEvents = [];
			},
			error : function(xhr, ajaxOptions, errorThrown) {
			}
		});
	}
}

function getBrowserNameAndInfo(){
	try {
		var ua= navigator.userAgent, tem, 
		M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
		if(/trident/i.test(M[1])){
			tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
			return 'IE '+(tem[1] || '');
		}
		if(M[1]=== 'Chrome'){
			tem= ua.match(/\bOPR\/(\d+)/);
			if(tem!= null) return 'Opera '+tem[1];
		}
		M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
		if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
		return M.join(' ');
	} catch (e) {
	}
	return '';
}

function trackNotValidElements(errorList){
	if(CommonPayment.metasearch || CommonPayment.source > 0){
		$(errorList).each(function(index, anError) {
			if(anError.element != undefined && (!anError.element.id || anError.element.id != document.activeElement.id)){
				if(anError.element.className.indexOf('genderRadio') == -1){
					try{
						var uiError = new Object();
						uiError.elementName = (anError.element.id ? anError.element.id : anError.element.name);
						uiError.warningText = anError.message;
						uiError.userInput = uiError.elementName.indexOf('pan') == 0 ? anError.element.value.replace(/\d/g,'*') : anError.element.value;
						uiError.errorType = 1;
						uiError.errorDate = getNowTime();
//						uiError.inputType = $(anError.element).attr("inputtype");
						CommonPayment.uiErrors.push(uiError);
					} catch (e) {
					}
				}
			}
		});
	}
}


function showVPOSRuleInfoMessages(messages){
	
	messages.forEach(function (message) {
		var messageText = FmtMessage.getMessage(message.fmt) ? FmtMessage.getMessage(message.fmt) : message.fmt;

		var cssClass = '';

		if (typeof message.type !== "undefined" ){
			if (message.type == 'WARNING'){
				cssClass = 'warning';
			}
			else if(message.type == 'ERROR'){
				cssClass = 'error';
			}
			else if(message.type == 'INFO'){
				cssClass = 'info';
			}
		}
		else {
			cssClass = 'warning';
		}

		var div = '<div class="' + cssClass + '">' + messageText + '</div>';

		$(".vposRuleInfoMessages").append(div);
		
	})
}
function clearVPOSRuleInfoMessages() {
	$(".vposRuleInfoMessages").empty();
}


function updateAccountPaymentStatusWithCurrentAmount(currentAmount) {
	if (!CommonPayment.userAnonym && CommonPayment.userBalance >= currentAmount){
		$("#account-balance-unavailable").hide();
		$("#account-balance-available").show();
	}
	else{
		$("#account-balance-available").hide();
		$("#account-balance-unavailable").show();
	}
}
